import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthContext } from './AuthContext.jsx';
import { GoogleAdapter } from './GoogleAdapter.jsx';
import { BYPASS_AUTH, BYPASS_VALUE } from './useAuth.js';

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

// Google is the only identity provider. Auth0 was removed on 2026-10-28; its
// token verification accepted any audience in the tenant and never checked
// email_verified, and roles are keyed on email. A missing client id throws at
// boot so the misconfiguration is loud instead of silent (the button would
// render but the flow would 401).
export function AppAuthProvider({ children }) {
  // VITE_BYPASS_AUTH short-circuits the whole tree: no provider env vars are
  // required, no login gate renders, and no token is attached to API calls (see
  // apiClient). Every other BYPASS_AUTH consumer already honors this; without it
  // here the boot-time throw and the login gate make the flag unusable. Local
  // dev only — deployed builds must ship BYPASS_AUTH=false.
  if (BYPASS_AUTH) {
    return <AuthContext.Provider value={BYPASS_VALUE}>{children}</AuthContext.Provider>;
  }

  if (!GOOGLE_CLIENT_ID) {
    throw new Error('VITE_GOOGLE_CLIENT_ID is required');
  }

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <GoogleAdapter>{children}</GoogleAdapter>
    </GoogleOAuthProvider>
  );
}
